import { FC, ReactNode, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { selectAppointmentLoading } from "@/store/features/appointment/selectors";
import { selectUserLoading } from "@/store/features/user/selectors";
import { fetchUserData, toggleUserLoading } from "@/store/features/user/slice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { Splash } from "@/ui";
import { cleanQueryParams, replaceQueryState } from "@/utils/query";

type Props = {
  children?: ReactNode;
}

const PATHS_WITHOUT_USER_DATA = ['/', '/diagnostics'];

const AppSetup: FC<Props> = ({ children }) => {
  const {i18n} = useTranslation();

  const dispatch = useAppDispatch();

  const userLoading = useAppSelector(selectUserLoading);
  const appointmentLoading = useAppSelector(selectAppointmentLoading);

  useEffect(() => {
    (async () => {
      const { pathname, search: query } = window.location;
      const searchParams = new URLSearchParams(query);

      if (PATHS_WITHOUT_USER_DATA.includes(pathname)) {
        const cleanedSearch = cleanQueryParams(searchParams, i18n);

        if (cleanedSearch) {
          replaceQueryState(cleanedSearch, pathname);
        }
        dispatch(toggleUserLoading(false));
        return;
      }

      if (!pathname.includes('/home')) {
        if (pathname.includes('/room')) {
          window.location.href = pathname.replace('/room', '/home');
        } else if (pathname.includes('/end')) {
          window.location.href = pathname.replace('/end', '/home');
        }
        return;
      }

      const roomId = pathname.split('/home/')[1];
      const cleanedSearch = cleanQueryParams(searchParams, i18n);

      if (cleanedSearch) {
        replaceQueryState(cleanedSearch, pathname);
      }

      dispatch(fetchUserData(roomId));
    })();
  }, [dispatch, i18n]);

  if (userLoading || appointmentLoading) {
    return <Splash />;
  }

  return children;
};

export default AppSetup;